import { GetStaticPaths, GetStaticProps } from 'next';

import StoryPage from '@components/Resources/Story/StoryPage';
import {
  ArticlePageParams,
  getEmptyStaticPaths,
  handleArticleStaticProps,
} from '@nextUtils/guidesUtils';
import { ArticleProps } from '@nextTypes/guides';

export const getStaticPaths: GetStaticPaths = getEmptyStaticPaths;

export const getStaticProps: GetStaticProps<
  ArticleProps,
  ArticlePageParams
> = context => handleArticleStaticProps(context, 'Stories');

export default StoryPage;
